import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/grailed-scams';

export default function Example() {
  return (
    <>
      <Head>
        <title>Grailed Seller Guide: 5 Tips To Avoid Getting Scammed</title>
        <meta
          name='description'
          content='Scams are common in online marketplaces–even sellers can become victims. From taking quality photos to being transparent with your buyers, here are ways you can steer clear of scammers.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/grailed-scams' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/grailed-scams' />
        <meta property='og:title' content='Grailed Seller Guide: 5 Tips To Avoid Getting Scammed' />
        <meta
          property='og:description'
          content='Scams are common in online marketplaces–even sellers can become victims. From taking quality photos to being transparent with your buyers, here are ways you can steer clear of scammers.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-05-29T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-05-29T00:00:00-00:00' />
        <meta property='article:tag' content='Grailed' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
